import { useEffect, useState } from 'react';

// Reactively tracks the active theme (the data-theme attribute on <html>),
// updating when the user toggles Light/Dark.
export function useThemeName() {
  const [theme, setTheme] = useState(
    () => (typeof document !== 'undefined' && document.documentElement.getAttribute('data-theme')) || 'default'
  );
  useEffect(() => {
    const el = document.documentElement;
    const obs = new MutationObserver(() => setTheme(el.getAttribute('data-theme') || 'default'));
    obs.observe(el, { attributes: true, attributeFilter: ['data-theme'] });
    setTheme(el.getAttribute('data-theme') || 'default');
    return () => obs.disconnect();
  }, []);
  return theme;
}
